import React, { FC } from 'react';
import classes from 'components/ColumnsBalancer/style/columnsBalancer.module.scss';

export const ColumnsBalancerItem: FC<React.PropsWithChildren> = ({ children }) => {
	return <div className={classes.columnsBalancer_item}>{children}</div>;
};
